export const TestimonialCardsCarousel = (function () {
  function initSwiper(selector) {
    // Initialize Swiper
    const swiper = new Swiper(selector, {
      effect: "cards",
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: false,
      slidesOffsetAfter: 0,
      watchOverflow: true,
      navigation: {
        nextEl: '#testimonial-cards-swiper-next-btn',
        prevEl: '#testimonial-cards-swiper-prev-btn',
      },
    });

    // Set initial state of buttons
    updateButtonsState(swiper);

    // Add event listeners to update button states when slides change
    swiper.on('slideChange', function() {
      updateButtonsState(swiper);
    });

    return swiper;
  }

  // Function to update button states
  function updateButtonsState(swiper) {
    const prevButton = document.querySelector('#testimonial-cards-swiper-prev-btn');
    const nextButton = document.querySelector('#testimonial-cards-swiper-next-btn');

    prevButton.style.opacity = swiper.isBeginning ? '0.5' : '1';
    prevButton.style.pointerEvents =  swiper.isBeginning ? 'none': 'auto'; 

    nextButton.style.opacity = swiper.isEnd ? '0.5' : '1';
    nextButton.style.pointerEvents = swiper.isEnd ? 'none' : 'auto';
  }
  
  // Public API
  return {
    initSwiper
  };
})();

export function initTestimonialCards() {
  //fix webflow designer display
  const slides = document.querySelectorAll('#testimonial-cards-section .testimonial-card-slide');
  slides.forEach(slide => {
    slide.style.position = "static";
  });
  
  //fix error of shadows
  const shadows = document.querySelectorAll('#testimonial-cards-section .swiper-slide-shadow');
  shadows.forEach(shadow => {
    shadow.style.borderRadius = "16px";
  });
}